import ContentLoader from 'react-content-loader';

const PurchasePinSkeleton = () => {
	return (
		<ContentLoader viewBox="0 0 400 60">
			<rect x="0" y="5" rx="5" ry="5" width="400" height="10" />
			<rect x="0" y="25" rx="5" ry="5" width="400" height="10" />
			<rect x="0" y="45" rx="5" ry="5" width="400" height="10" />
		</ContentLoader>
	);
};

export default PurchasePinSkeleton;
